export default __webpack_public_path__ + "static/media/welcome-2.6ef11c74.jpg";